/**
 * Teacher service URL (node)
 */
export const teacherServiceURL = window.APP_CONFIG.TEACHER_SERVICE;
